import styled from "styled-components";
import { siteDarkBlue, sitePurple } from "../../providers/Theme";

export const Section = styled.section`
  background: ${siteDarkBlue};
  padding: 3.5rem 1.5rem;
  position: relative;
  z-index: 0;
`;

export const Inner = styled.div`
  max-width: 72rem;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 2.5rem;

  ${({ theme }) => theme.lg`
    flex-direction: row;
    align-items: center;
    gap: 4rem;
  `}
`;

export const TextSide = styled.div`
  ${({ theme }) => theme.lg`
    flex: 0 0 38%;
  `}
`;

export const SectionTitle = styled.h2`
  color: white;
  font-weight: 800;
  font-size: 2rem;
  line-height: 1.2;
  margin-bottom: 1.25rem;

  ${({ theme }) => theme.md`
    font-size: 2.5rem;
  `}
`;

export const SectionBody = styled.p`
  color: rgba(255, 255, 255, 0.88);
  font-size: 1.35rem;
  line-height: 1.65;
  margin-bottom: 2rem;

  ${({ theme }) => theme.md`
    font-size: 1.2rem;
  `}
`;

export const WatchButton = styled.button`
  background: ${sitePurple};
  border: none;
  border-radius: 0.6rem;
  color: white;
  font-weight: 700;
  font-size: 1.3rem;
  padding: 0.7rem 1.8rem;
  cursor: pointer;
  transition: opacity 0.15s ease;

  &:hover {
    opacity: 0.88;
  }
`;

export const VideoSide = styled.div`
  flex: 1;
`;

export const VideoContainer = styled.div`
  position: relative;
  padding-bottom: 56.25%;
  height: 0;
  overflow: hidden;
  border-radius: 10px;

  iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: 0;
  }
`;
